// extracted by mini-css-extract-plugin
export default {"display":"Nv5LU","iframe":"GN17V"};